import { ApplicationMimeTypesEnum } from "../../common/enums/ApplicationMimeTypesEnum";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import restService from "../rest-service/RestService";
import { AuditActionEnum, AuditActionSubTypeEnum, IAuditTrail } from "./Models";


export interface IAuditTrailFilter  {
        startDate?: Date;
        endDate?: Date;
        objectType?: eLynxObjectTypeEnum;
        objectName?: string;
        objectID?: number;
        //public IEnumerable<int> ObjectIDs { get; set; }
        action?: AuditActionEnum;
        actionSubType?: AuditActionSubTypeEnum;
        userLogin?: string;
        oldValue?: string;
        newValue?: string;
        parentObjectType?: eLynxObjectTypeEnum;
        parentObjectID?: number;
        parentObjectName?: string;
        additionalInfo?: string;
        additionalID?: number;
        maxRows: number;
        searchText?: string;
}

export interface IAuditTrailFilterExport {
    mimeType: ApplicationMimeTypesEnum;
    notificationKey: string;
    filter: IAuditTrailFilter;
}

const AuditReportingDataService = {


    getData: async function (
        groupID: number,
        startDate: Date | undefined,
        endDate: Date | undefined,
        auditAction: AuditActionEnum | undefined,
        objectType: eLynxObjectTypeEnum | undefined,
        userName: string | undefined,
        objectName: string | undefined,
        oldValue: string | undefined,
        newValue: string | undefined,
        additionalInfo: string | undefined,
        searchText: string | undefined,
        maxRows: number,        
        signal?: AbortSignal
    ): Promise<IAuditTrail[]> {

        const filter: IAuditTrailFilter = {
            startDate: startDate,
            endDate: endDate,
            objectType: objectType,
            objectName: objectName,
            //objectID: 218,
            //public IEnumerable<int> ObjectIDs { get; set; }
            action: auditAction,
            //actionSubType?: AuditActionSubTypeEnum;
            userLogin: userName,
            oldValue: oldValue,
            newValue: newValue,
            //parentObjectType?: eLynxObjectTypeEnum;
            //parentObjectID?: number;
            //parentObjectName?: string;
            additionalInfo: additionalInfo,
            //additionalID?: number;
            maxRows: maxRows,
            searchText: (searchText?.trim()?.length ?? 0) > 0 ? searchText?.trim() : undefined
        };

        const response = await restService.post<IAuditTrailFilter, IAuditTrail[]>(`groups/${groupID}/audittrail`, filter, signal);
        return response.data;
    },
    exportData: async function (
        groupID: number,
        notificationKey: string,
        mimeType: ApplicationMimeTypesEnum,
        auditFilter: IAuditTrailFilter,
        signal?: AbortSignal
    ): Promise<void> {

        const filter: IAuditTrailFilterExport = {
            notificationKey: notificationKey,
            mimeType: mimeType,
            filter: auditFilter
        }

        const response = await restService.post<IAuditTrailFilterExport, void>(`groups/${groupID}/audittrail/export`, filter, signal);
        return response.data;
    }



};

export default AuditReportingDataService;